module.exports = __webpack_public_path__ + "phone1.5fb2feef.jpg";